import { IMAGE_RESIZE_TARGETS } from '@/shared/constants'
import { resizeImage } from '@/shared/utils/image-resize-utils'

export interface ResizedPoiImage {
  thumbnail: Blob
  medium: Blob
  large: Blob
}

export async function resizePoiImage(file: File): Promise<ResizedPoiImage> {
  const [thumbnail, medium, large] = await Promise.all([
    resizeImage(file, IMAGE_RESIZE_TARGETS.thumbnail),
    resizeImage(file, IMAGE_RESIZE_TARGETS.medium),
    resizeImage(file, IMAGE_RESIZE_TARGETS.large),
  ])

  return { thumbnail, medium, large }
}
